import React from "react";
import { motion } from "framer-motion";
import SimpleChartBuilder from "../templates/SimpleChartBuilder";

const ChartStepTemplate = ({ content }) => {
  // Extensive debugging logs
  console.log(
    "ChartStepTemplate - Entire Content Object:",
    JSON.stringify(content, null, 2)
  );
  console.log("ChartStepTemplate - Content Type:", typeof content);
  console.log(
    "ChartStepTemplate - Content Keys:",
    content ? Object.keys(content) : "No content"
  );

  // Default sample data if no data is provided
  const defaultData = [
    { category: "Brown", value: 12, color: "#8B4513" },
    { category: "Blue", value: 8, color: "#6FA4FF" },
    { category: "Green", value: 5, color: "#4CAF50" },
    { category: "Hazel", value: 3, color: "#CD853F" },
  ];

  // Fallback in case content is undefined
  if (!content) {
    return (
      <div className="bg-red-100 p-4 text-red-800">
        Error: No content provided to ChartStepTemplate
      </div>
    );
  }

  // Helper function to render tips
  const renderTips = () => {
    if (!content.tips) return null;

    return (
      <div className="mt-4 bg-[#EFEAFC]/20 p-3 rounded-lg">
        <ul className="space-y-2 text-[#0D065B]">
          {content.tips.map((tip, index) => (
            <li key={index} className="flex items-center gap-2">
              <span className="text-xl">{tip.icon}</span>
              <span>{tip.text}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="w-full max-w-6xl mx-auto">
      <div className="space-y-6">
        {/* Debug Information */}
        <div className="bg-yellow-100 p-4 rounded-lg">
          <h3 className="font-bold mb-2">Debug Information</h3>
          <pre className="text-xs overflow-x-auto">
            {JSON.stringify(content, null, 2)}
          </pre>
        </div>

        {/* Title and description section */}
        {(content.title || content.description) && (
          <div className="mb-4">
            {content.title && (
              <h2 className="text-xl font-bold text-[#0D065B] mb-2">
                {content.title}
              </h2>
            )}
            {content.description && (
              <p className="text-sm text-[#5F29FF]">{content.description}</p>
            )}
          </div>
        )}

        {/* Chart visualization component */}
        <SimpleChartBuilder
          currentStep={content.chartStep || 1}
          title={
            content.chartTitle || content.title || "Eye Colors in Our Class"
          }
          data={defaultData}
        />

        {/* Tips section */}
        {renderTips()}
      </div>
    </div>
  );
};

export default ChartStepTemplate;
